<!--
  详情页 - 左侧基本信息
  props:
    detailData: 详情数据
    rates: 星星star 数据
    moduleName: 模块名
  emit:
    openDetail: 打开详情页
 -->

<template>
  <div class="basic-item">
    <div v-if="rates.length">
      <h3 class="title"><slot name="title"></slot></h3>
      <div class="content">
        <ul>
          <li class="item" v-for="item in rates">
            <span class="label rate">{{item.attrName}}:</span>
            <el-rate
              :value="item.value4Show | toNumber"
              :colors="item.value4Show | toColor"
              disabled>
            </el-rate>
            <span class="tag low" v-if="item.value4Show < 3">低</span>
            <span class="tag high" v-else-if="item.value4Show > 4">高</span>
            <span class="tag mid" v-else>中</span>
          </li>
        </ul>
      </div>
    </div>
    <!-- <h3 class="title" v-if="moduleName = 'paymentApi'">回款信息</h3> -->
    <h3 class="title">基本资料</h3>
    <div class="content">
      <ul>
        <li class="item" v-for="(item,index) in detailData" :key="index">
          <span class="label">{{item.attrName}}:</span>
          <template v-if="[5,6,7,8,10,0].indexOf(item.fieldType) === -1 && !item.popType">
            <!-- 有注释说明的项 -->
            <template v-if="['contractCost', 'cost', 'grossProfit', 'grossProfitRate', 'cashProfit', 'cashProfitRate'].indexOf(item.attr) > -1">
              <span :class="{'costRed': (item.attr === 'grossProfitRate' || item.attr === 'cashProfitRate') && judgeNegative(item.value4Show), 'text':true}">{{item.value4Show || '--'}}</span>
              <el-tooltip :content="tooltipObj[item.attr][moduleName] || tooltipObj[item.attr]" placement="top" effect="light">
                <span class="icon el-icon-question"></span>
              </el-tooltip>
            </template>
            <template v-else>
              <span class="text">{{item.value4Show || '--'}}</span>
            </template>
          </template>
          <template v-else-if="[5, 6].indexOf(item.fieldType) > -1">
            <div class="img-box">
              <span class="img" v-for="(url, index) in strToArr(item.value4Show)" @click="openLightbox(url)" :key="index">
                <img :src="url" height="40" width="40">
              </span>
            </div>
          </template>
           <!-- 附件信息 -->
          <template v-else-if="item.fieldType===8">
            <attachment-preview v-if="item.value4Show" :data="item.value4Show"></attachment-preview>
          </template>
          <template v-else-if="item.fieldType === 7">
            <div class="text">
              <p v-for="(p, index) in paragraph(item.value4Show)" :key="index">{{p}}</p>
            </div>
          </template>
          <template v-else-if="item.popType === 1">
            <span class="text" v-if="!item.multiValue">
              <a @click.prevent="openDetail(item.popModel, item.id, item.isRed)">{{item.value4Show}}</a>
            </span>
            <span v-else>
              <span v-for="(n, index) in item.multiValue">
                <a class="text" @click="openDetail(n.popModel, n.id, item.isRed)">{{n.value4Show}}</a>
                <span v-if="index !== item.multiValue.length-1">、</span>
              </span>
            </span>
          </template>
          <template v-else-if="item.fieldType===10">
            <span class="text">
              <el-rate
                :value="item.value4Show | toNumber"
                disabled>
              </el-rate>
            </span>
          </template>
          <template v-else-if="item.attr === 'phone'">
            <div class="phone-arr">
              <p class="text" v-for="(p, index) in strsplit(item.value4Show)" :key="index">{{p}}</p>
            </div>
          </template>
          <template v-else>
            <span class="text">{{item.value4Show || '--'}}</span>
          </template>
        </li>
      </ul>
    </div>

    <div v-if="origin && JSON.stringify(origin) !== '{}'">
      <h3 class="title">原回款信息</h3>
      <div class="content">
        <ul>
          <li class="item">
            <span class="label">回款编号:</span>
            <a class="text" @click="openDetail(origin.paymentNo.popModel, origin.paymentNo.id)">{{origin.paymentNo.paymentNo || '--'}}</a>
          </li>
          <li class="item">
            <span class="label">计划回款金额:</span>
            <span class="text">{{origin.amount}}</span>
          </li>
          <li class="item">
            <span class="label">实收金额:</span>
            <span class="text">{{origin.realAmount}}</span>
          </li>
          <li class="item">
            <span class="label">未收金额</span>
            <span class="text">{{origin.unAmount}}</span>
          </li>
          <li class="item">
            <span class="label">回款状态:</span>
            <span class="text">{{origin.status || '--'}}</span>
          </li>
          <li class="item">
            <span class="label">回款类型:</span>
            <span class="text">{{origin.paymentType || '--'}}</span>
          </li>
          <li class="item">
            <span class="label">负责人:</span>
            <span class="text">{{origin.userName || '--'}}</span>
          </li>
        </ul>
      </div>
    </div>

    <div v-if="otherDetail">
      <h3 class="title">其他信息</h3>
      <div class="content">
        <ul>
          <li class="item" v-for="(value, key) in otherDetail">
            <span class="label">{{key}}:</span>
            <span class="text">{{value}}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import lightBox from 'src/plugins/lightbox'
import { mapActions } from 'vuex'
import attachmentPreview from 'components/common/attachment-preview'

export default {
  props: {
    detailData: {
      type: Array
    },
    otherDetail: {
      type: Object
    },
    rates: {
      type: Array
    },
    origin: {
      type: Object
    },
    moduleName: {
      type: String
    }
  },
  data () {
    return {
      tooltipObj: {
        contractCost: '合同成本 = 合同产品总成本 + 其他费用；其中“合同产品总成本”在实际出库前由预估产品成本计算而得，实际出库之后取实际产品成本计算而得，故而“合同成本”字段会根据实际情况进行变动及更新。',
        cost: '机会成本为产品成本',
        grossProfit: {
          contractApi: '合同毛利= 合同金额 - 合同产品总成本 - 其他费用',
          opportunityApi: '机会毛利 = 预计金额 - 产品成本'
        },
        grossProfitRate: {
          contractApi: '合同毛利率 = 合同毛利/合同金额*100%',
          opportunityApi: '机会毛利率 = 机会毛利/预计金额*100%'
        },
        cashProfit: '现金毛利=合同已收款金额-合同成本',
        cashProfitRate: '现金毛利率=现金毛利/合同已收款金额'
      }
    }
  },
  methods: {
    ...mapActions([
      'setRedStatus'
    ]),
    // 判断毛利率是否为负数(val是后端格式化了的字符串)
    judgeNegative (val) {
      var haveTag = val.substr(0, 1)
      if (haveTag === '-') {
        return true
      } else {
        return false
      }
    },
    // 将换行内容分割为数组
    paragraph (str) {
      if (str) {
        return str.split('\n')
      } else {
        return []
      }
    },
    strToArr (str) {
      return window.utils.json(str)
    },
    openDetail (type, id, isRed) {
      this.setRedStatus(isRed === true)
      this.$emit('openDetail', type, id)
    },
    openLightbox (url) {
      lightBox(url)
    },
    // 将字符串分割为数组
    strsplit (str) {
      return str.split(', ')
    }
  },
  filters: {
    toNumber (str) {
      return Number(str)
    },
    toColor (str) {
      str = Number(str)
      if (str < 3) {
        return ['#78c06e', '#78c06e', '#78c06e']
      } else if (str > 4) {
        return ['#ff6161', '#ff6161', '#ff6161']
      } else {
        return ['#ff7c35', '#ff7c35', '#ff7c35']
      }
    }
  },
  components: {
    attachmentPreview
  }
}
</script>

<style lang="less">
  @import '../../assets/less/variable.less';
  .basic-item {
    .title {
      background-color: @bg-lightblue;
      height: 40px;
      line-height: 40px;
      padding: 0 15px;
    }
    .content {
      clear: both;
      padding: 10px 20px 20px;
      .item {
        display: table;
        padding-top: 6px;
        .label, .text {
          font-size: 13px;
          line-height: 20px;
        }
        .label {
          display: inline-block;
          width: 84px;
          text-align: right;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: @light-gray;
          &.rate {
            text-align: left;
          }
        }
        .text {
          vertical-align: top;
          display: table-cell;
          padding-left: 10px;
          word-break: break-all;
        }
        .tag {
          display: inline-block;
          margin-left: 20px;
          font-size: 12px;
          width: 20px;
          height: 20px;
          line-height: 20px;
          text-align: center;
          border-radius: 2px;
          color: #FFF;
          transform: scale(0.8);
          &.high{
            background-color: #ff6161;
          }
          &.mid{
            background-color: #ff7c35;
          }
          &.low{
            background-color: #78c06e;
          }
        }
        .el-rate {
          display: inline-block;
          vertical-align: top;
          padding-top: 2px;
          .el-rate__icon {
            font-size: 16px;
          }
        }
        .img-box {
          display: table-cell;
          padding-left: 10px;
          word-break: break-all;
          vertical-align: top;
          .img {
            margin-right: 6px;
          }
          .file {
            line-height: 20px;
          }
        }
        .phone-arr {
          display: table-cell;
          word-break: break-all;
          vertical-align: top;
          .text {
            display: block;
          }
        }
        /deep/.el-icon-question {
          position: absolute;
          right: 6px;
        }
        .costRed {
          color: #ff6161;
        }
        .file-info {
          margin: 0;
          padding: 0;
          border-top: 0;
          .label {
            display: none;
          }
        }
      }  
    }
  }
  @media screen and (max-width: 1366px) {
    .basic-item {
      .content {
        padding: 8px 10px 10px;
        .item {
          .rate {
            width: 70px;
          }
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// basic-item.vue?8983e0aa